import type { ReactNode } from 'react'
import './Hero.css'

export interface HeroProps {
  /** Requis sauf si `image` est fourni — l'un des deux, jamais aucun. */
  imageSrc?: string
  imageAlt?: string
  /**
   * Visuel composé par l'appelant, prioritaire sur `imageSrc` : c'est par là
   * que passe un `MediaImage` piloté par le back-office. Le slot est enveloppé
   * dans un conteneur en position absolue — sans lui, un visuel inséré tel quel
   * perdrait le calage plein cadre que la classe `.azoya-hero-photo` donne à
   * l'`<img>` par défaut, et la mise en page du hero s'effondrerait.
   */
  image?: ReactNode
  eyebrow?: ReactNode
  titleMain: string
  titleEmphasis: string
  description?: ReactNode
  cta: ReactNode
  scrollCueLabel?: string
}

export function Hero({
  imageSrc,
  imageAlt,
  image,
  eyebrow,
  titleMain,
  titleEmphasis,
  description,
  cta,
  scrollCueLabel = 'Découvrir',
}: HeroProps) {
  return (
    <div className="azoya-hero">
      <div className="azoya-hero-media">
        {image ? (
          <span className="azoya-hero-photo-slot">{image}</span>
        ) : (
          <img src={imageSrc} alt={imageAlt} className="azoya-hero-photo" />
        )}
        <span className="azoya-hero-scrollcue" aria-hidden="true">
          <span className="azoya-hero-scrollcue-label">{scrollCueLabel}</span>
          <span className="azoya-hero-scrollcue-chevron">⌄</span>
        </span>
      </div>
      <div className="azoya-hero-panel">
        {eyebrow && <span className="azoya-hero-eyebrow">{eyebrow}</span>}
        <h1 className="azoya-hero-title">
          {titleMain} <em>{titleEmphasis}</em>
        </h1>
        {description && <p className="azoya-hero-description">{description}</p>}
        <div className="azoya-hero-actions">{cta}</div>
      </div>
    </div>
  )
}
